import React, { useState } from 'react';
import { LoyaltyStatsModal } from './LoyaltyStatsModal';

export const LoyaltyBadge = ({ loyaltyData }) => {
    const [statsOpen, setStatsOpen] = useState(false);

    if (!loyaltyData || !loyaltyData.Level || loyaltyData.Level === 0) return null;

    return (
        <>
            <button className="loyalty_badge" onClick={() => setStatsOpen(true)}>
                <img
                    src={`/icons/loyalty/${loyaltyData.Level}.svg`}
                    alt={`${loyaltyData.Level} уровень`}
                    className="loyalty_badge_icon"
                    style={{ width: 24, height: 24 }}
                />
                <span className="loyalty_badge_text">{loyaltyData.Level} уровень</span>
            </button>

            <LoyaltyStatsModal
                open={statsOpen}
                onClose={() => setStatsOpen(false)}
                loyaltyData={loyaltyData}
            />
        </>
    );
};
